import React, { Component } from 'react'
import DOMPurify from 'dompurify'
import Config from '../../commons/config/Config.js'

class PoliticaPrivacidadPublica extends Component {
	constructor(props) {
		super(props)
		this.state = { politica: null, cargando: true, error: false }
		this.videoRandom = 1 + Math.floor((4 - 1) * Math.random())
	}

	componentDidMount() {
		document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page'
		document.body.setAttribute('data-col', '1-column')

		fetch(Config.get('apiUrlBase') + '/public/politicas-privacidad/vigente', {
			method: 'GET',
			headers: { 'Accept': 'application/json' }
		})
			.then(response => {
				if (response.status === 404) {
					this.setState({ cargando: false, politica: null })
					return null
				}
				return response.json()
			})
			.then(data => {
				if (data) this.setState({ politica: data, cargando: false })
			})
			.catch(() => {
				this.setState({ cargando: false, error: true })
			})
	}

	render() {
		const { politica, cargando, error } = this.state

		return (
			<div className="app-content content">
				<div className="content-wrapper">
					<div className="content-header row"></div>
					<div className="content-body">

						<video className="video-login-bg" autoPlay muted loop poster={process.env.PUBLIC_URL + '/images/images-login/image' + this.videoRandom + '.png'}>
							<source src={process.env.PUBLIC_URL + '/images/videos-login/video' + this.videoRandom + '.mp4'} type="video/mp4" />
						</video>

						<section className="flexbox-container">
							<div className="col-12 d-flex align-items-center justify-content-center">
								<div className="col-11 col-sm-10 col-md-8 col-lg-7 p-0" style={{ maxWidth: '760px', position: 'relative' }}>
									<div className="card border-0 m-0" style={{ borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)' }}>

										{cargando && (
											<div className="card-body text-center py-5">
												<i className="fa fa-spinner fa-spin fa-2x text-muted"></i>
											</div>
										)}

										{!cargando && error && (
											<div className="card-body text-center py-5">
												<i className="fa fa-exclamation-triangle fa-2x text-danger mb-3 d-block"></i>
												<p className="text-muted">No se pudo cargar la política de privacidad.</p>
											</div>
										)}

										{!cargando && !error && !politica && (
											<div className="card-body text-center py-5">
												<i className="fa fa-file-text-o fa-2x text-muted mb-3 d-block"></i>
												<p className="text-muted">No hay una política de privacidad vigente.</p>
											</div>
										)}

										{!cargando && !error && politica && (
											<React.Fragment>
												<div className="card-header bg-fleet border-0" style={{ borderRadius: '1rem 1rem 0 0', padding: '1.25rem 1.5rem' }}>
													<h4 className="text-white mb-0">
														{politica.titulo}
														<small className="ml-2" style={{ fontSize: '13px', opacity: 0.85 }}>
															v{politica.version}
														</small>
													</h4>
												</div>
												<div
													className="card-body"
													style={{ padding: '1.5rem', lineHeight: '1.7', maxHeight: '70vh', overflowY: 'auto' }}
													dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(politica.contenido || '') }}
												/>
												<div className="card-footer border-0 text-right text-muted" style={{ fontSize: '12px', borderRadius: '0 0 1rem 1rem' }}>
													Versión {politica.version}
												</div>
											</React.Fragment>
										)}

									</div>
								</div>
							</div>
						</section>

					</div>
				</div>
			</div>
		)
	}
}

export default PoliticaPrivacidadPublica
